import React from 'react';
import { Link } from 'react-router-dom';

const SitemapPage = () => {
  // Organize links by category – adjust to match your site structure
  const sitemap = {
    "Main": [
      { name: "Home", path: "/" },
      { name: "Placement", path: "/placement" },
      { name: "Gallery", path: "/gallery" },
      { name: "Contact", path: "/contact" },
    ],
    "About RDS": [
      { name: "Vision & Mission", path: "/vision" },
      { name: "University", path: "/university" },
      { name: "Principal's Message", path: "/principal-message" },
      { name: "Chairman's Message", path: "/chairman" },
    ],
    "Courses": [
      { name: "B. Pharma", path: "/bpharma" },
      { name: "D. Pharma", path: "/dpharma" },
      { name: "Fee Structure", path: "/fee-structure" },
    ],
    "Admission": [
      { name: "Admission Overview", path: "/admission" },
      { name: "Registration Form", path: "/pdfsection" },
      { name: "Prospectus", path: "/prospectus" },
      { name: "RDS Affiliation", path: "/rdsaffiliation" },
      { name: "Pharmacy Schedule", path: "/pharmacyschedule" },
      { name: "Committee", path: "/committee" },
    ],
    "Legal": [
      { name: "Privacy Policy", path: "/privacy-policy" },
      { name: "Terms of Use", path: "/terms-of-use" },
    ]
  };

  return (
    <div className="py-16 px-4 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center">Sitemap</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Object.entries(sitemap).map(([category, links]) => (
            <div key={category} className="bg-white rounded-xl shadow-md p-6">
              <h2 className="text-xl font-semibold text-blue-600 mb-4 border-b pb-2">{category}</h2>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-gray-600 hover:text-blue-600 transition">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;